module.exports = __webpack_public_path__ + "DINNextRoundedLTPro-Medium.woff?3c58d966b8efd9e3f28e979140934967";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextRoundedLTPro-Medium.woff
// module id = 1407
// module chunks = 0